import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import VideosPage from "@/pages/videos/page";
import VideoDetailPage from "@/pages/videos/detail/[id]/page";
import ArticlesPage from "@/pages/articles/page";
import ArticleDetailPage from "@/pages/articles/detail/[id]/page";
import CommunityPage from "@/pages/community/page";
import CommunityDetailPage from "@/pages/community/detail/[id]/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/videos",
    element: <VideosPage />,
  },
  {
    path: "/videos/detail/:id",
    element: <VideoDetailPage />,
  },
  {
    path: "/articles",
    element: <ArticlesPage />,
  },
  {
    path: "/articles/detail/:id",
    element: <ArticleDetailPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/community/detail/:id",
    element: <CommunityDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;